import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, Fragment as _Fragment, createTextVNode as _createTextVNode, vModelText as _vModelText, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "text-default" }, "Not Available", -1 /* HOISTED */)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "text-default" }, "Not Available", -1 /* HOISTED */)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_10 = {
  key: 0,
  class: "me-2 fas fa-mobile-alt"
}
const _hoisted_11 = ["href"]
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  key: 2,
  class: "text-end"
}
const _hoisted_15 = { class: "btn table-btn" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-comment-dots icon-size text-info" }, null, -1 /* HOISTED */)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = {
  key: 1,
  class: "icon-cur"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-comment-dots icon-size" }, null, -1 /* HOISTED */)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-edit icon-size" }, null, -1 /* HOISTED */)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exchange-alt" }, null, -1 /* HOISTED */)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-sticky-note icon-size" }, null, -1 /* HOISTED */)
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-paperclip icon-size" }, null, -1 /* HOISTED */)
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn px-1 py-0 ms-1 btn-outline-primary icon-size",
  "data-bs-toggle": "dropdown",
  id: "ReferralRow__Actions${id}"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-ellipsis-h icon-size" })
], -1 /* HOISTED */)
const _hoisted_31 = {
  class: "dropdown-menu",
  "aria-labelledby": "ReferralRow__Actions${id}"
}
const _hoisted_32 = { key: 1 }
const _hoisted_33 = {
  key: 3,
  colspan: "4"
}
const _hoisted_34 = {
  key: 4,
  colspan: "2",
  class: "text-end"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "big-text" }, [
  /*#__PURE__*/_createElementVNode("i", null, "Non-Admit in Progress")
], -1 /* HOISTED */)
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = {
  key: 0,
  class: "non-admit-form-row-two"
}
const _hoisted_38 = ["colspan"]
const _hoisted_39 = { "au-target-id": "97" }
const _hoisted_40 = { class: "card-body p-0" }
const _hoisted_41 = {
  class: "p-2 pb-0 d-flex justify-content-center au-target",
  "au-target-id": "2034"
}
const _hoisted_42 = { class: "p-2 form-group" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", { for: "non-admit-date" }, [
  /*#__PURE__*/_createTextVNode(" Non-Admit Date "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_44 = { class: "input-group date datepickerInput" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_46 = { class: "p-2 form-group mw-60" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("label", { for: "non-admit-reason" }, [
  /*#__PURE__*/_createTextVNode(" Non-Admit Reason "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_48 = { key: 0 }
const _hoisted_49 = {
  key: 1,
  class: "new-typeahead"
}
const _hoisted_50 = { class: "multi-select-filter" }
const _hoisted_51 = { class: "d-flex justify-content-center" }
const _hoisted_52 = {
  key: 0,
  class: "col-6 pb-4 form-group"
}
const _hoisted_53 = { for: "non-admit-comments" }
const _hoisted_54 = /*#__PURE__*/_createTextVNode(" Comments ")
const _hoisted_55 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_56 = { class: "text-center" }
const _hoisted_57 = {
  key: 1,
  class: "edit-row"
}
const _hoisted_58 = ["colspan"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormatName = _resolveComponent("FormatName")!
  const _component_EmptyTextHandler = _resolveComponent("EmptyTextHandler")!
  const _component_TablePrompt = _resolveComponent("TablePrompt")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_NewTypeahead = _resolveComponent("NewTypeahead")!
  const _component_TagsInput = _resolveComponent("TagsInput")!
  const _component_CommentInput = _resolveComponent("CommentInput")!
  const _component_TransferPatientForm = _resolveComponent("TransferPatientForm")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("tr", {
      class: _normalizeClass(`${_ctx.isDeleteRequested || _ctx.isNonAdmitRequested || _ctx.isTransferRequested ? 'edit-row' : ''}`)
    }, [
      _createElementVNode("td", null, [
        (_ctx.referral.referralDate)
          ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.formatDateFromDate(_ctx.referral.referralDate)), 1 /* TEXT */))
          : (_openBlock(), _createElementBlock("small", _hoisted_2, _hoisted_4))
      ]),
      _createElementVNode("td", null, [
        (_ctx.referral.requestedStartOfCareDate)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.formatDateFromDate(_ctx.referral.requestedStartOfCareDate)), 1 /* TEXT */))
          : (_openBlock(), _createElementBlock("small", _hoisted_6, _hoisted_8))
      ]),
      _createElementVNode("td", null, [
        _createVNode(_component_FormatName, {
          "first-name": _ctx.referral.firstName,
          "last-name": _ctx.referral.lastName
        }, null, 8 /* PROPS */, ["first-name", "last-name"]),
        _hoisted_9,
        (_ctx.referral.phoneNumbers && _ctx.referral.phoneNumbers?.length > 0)
          ? (_openBlock(), _createElementBlock("i", _hoisted_10))
          : _createCommentVNode("v-if", true),
        _createElementVNode("a", {
          href: `tel:${_ctx.getPhoneNumber(_ctx.referral.phoneNumbers)}`
        }, _toDisplayString(_ctx.formatPhone(_ctx.getPhoneNumber(_ctx.referral.phoneNumbers))), 9 /* TEXT, PROPS */, _hoisted_11)
      ]),
      _createElementVNode("td", null, [
        _createVNode(_component_EmptyTextHandler, {
          text: _ctx.referral.branchName
        }, null, 8 /* PROPS */, ["text"])
      ]),
      (_ctx.referral.lineOfService != null)
        ? (_openBlock(), _createElementBlock("td", _hoisted_12, _toDisplayString(_ctx.lineOfServiceEnumMap.getEnumName(_ctx.referral.lineOfService)), 1 /* TEXT */))
        : (_openBlock(), _createElementBlock("td", _hoisted_13, [
            _createVNode(_component_EmptyTextHandler, { text: _ctx.referralApplication }, null, 8 /* PROPS */, ["text"])
          ])),
      _createElementVNode("td", null, [
        _createVNode(_component_EmptyTextHandler, {
          text: _ctx.referral.referralSource
        }, null, 8 /* PROPS */, ["text"])
      ]),
      _createElementVNode("td", null, [
        _createVNode(_component_EmptyTextHandler, {
          text: _ctx.formatDateFromDate(_ctx.referral.dateOfBirth)
        }, null, 8 /* PROPS */, ["text"])
      ]),
      _createElementVNode("td", null, [
        _createVNode(_component_EmptyTextHandler, {
          text: _ctx.getGenderTypes(_ctx.referral.gender)
        }, null, 8 /* PROPS */, ["text"])
      ]),
      _createElementVNode("td", null, [
        _createVNode(_component_EmptyTextHandler, {
          text: _ctx.referral.createdBy
        }, null, 8 /* PROPS */, ["text"])
      ]),
      _createElementVNode("td", null, [
        _createVNode(_component_EmptyTextHandler, {
          text: _ctx.referral.liaison
        }, null, 8 /* PROPS */, ["text"])
      ]),
      _createElementVNode("td", null, [
        _createVNode(_component_EmptyTextHandler, {
          text: _ctx.referral.tags
        }, null, 8 /* PROPS */, ["text"])
      ]),
      (!_ctx.isDeleteRequested && !_ctx.isNonAdmitRequested)
        ? (_openBlock(), _createElementBlock("td", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              (_ctx.referral.comments?.length > 0)
                ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_18)), [
                    [_directive_tooltip, { title: _ctx.referral.comments }]
                  ])
                : (_openBlock(), _createElementBlock("span", _hoisted_19, _hoisted_21))
            ]),
            (_ctx.isEditAllowed || _ctx.isDeleteAllowed)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (_ctx.isEditAllowed)
                    ? _withDirectives((_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn table-btn px-2 btn-outline-info au-target",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editReferralForSelectedPatient()))
                      }, _hoisted_23)), [
                        [_directive_tooltip, { title: 'Edit Referral', placement: 'bottom' }]
                      ])
                    : _createCommentVNode("v-if", true),
                  _withDirectives((_openBlock(), _createElementBlock("button", {
                    type: "button",
                    class: "btn table-btn btn-outline-info",
                    tooltip: "title: Refer Patient to Another Provider; placement: bottom",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openTransferForm()))
                  }, _hoisted_25)), [
                    [_directive_tooltip, { title: 'Refer Patient to Another Provider', placement: 'bottom' }]
                  ]),
                  (_ctx.isHomeHealthAgency || _ctx.isHospiceAgency || _ctx.isPalliativeAgency)
                    ? _withDirectives((_openBlock(), _createElementBlock("button", {
                        key: 1,
                        type: "button",
                        class: _normalizeClass([{
                        'btn-outline-info color-info': _ctx.referral?.hasPreadmissionNote,
                        'color-default': !_ctx.referral?.hasPreadmissionNote
                    }, "btn table-btn px-1 au-target"]),
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openPreadmissionModal()))
                      }, _hoisted_27, 2 /* CLASS */)), [
                        [_directive_tooltip, { title: 'Preadmission Notes', placement: 'bottom' }]
                      ])
                    : _createCommentVNode("v-if", true),
                  _withDirectives((_openBlock(), _createElementBlock("button", {
                    type: "button",
                    class: "btn table-btn px-2 btn-outline-info au-target",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openAddDocumentModal(_ctx.referral.application)))
                  }, _hoisted_29)), [
                    [_directive_tooltip, { title: 'Attach Document', placement: 'bottom' }]
                  ]),
                  _hoisted_30,
                  _createElementVNode("div", _hoisted_31, [
                    (_ctx.isEditAllowed)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          class: "dropdown-item",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openNonAdmitForm(true))),
                          href: "javascript:void(0);"
                        }, " Non-Admit "))
                      : _createCommentVNode("v-if", true),
                    (_ctx.isConvertToPendingAllowed)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 1,
                          class: "dropdown-item",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleConvertToPending(_ctx.referral))),
                          href: "javascript:void(0);"
                        }, " Convert to Pending "))
                      : _createCommentVNode("v-if", true),
                    (_ctx.canShowPremium)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 2,
                          class: "dropdown-item near-ai-button",
                          href: "javascript:void(0);",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleFindNearByEmployees(_ctx.referral)))
                        }, " Find Nearby Employees "))
                      : _createCommentVNode("v-if", true),
                    (_ctx.isDeleteAllowed)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 3,
                          class: "dropdown-item",
                          href: "javascript:void(0);",
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.confirmDeleteReferral()))
                        }, " Delete "))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _createCommentVNode("  ")
                ], 64 /* STABLE_FRAGMENT */))
              : (_openBlock(), _createElementBlock("i", _hoisted_32, " No Actions "))
          ]))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" Delete "),
      (_ctx.isDeleteRequested)
        ? (_openBlock(), _createElementBlock("td", _hoisted_33, [
            _createVNode(_component_TablePrompt, {
              "ok-text": "Delete",
              cancelText: "Cancel",
              name: "Referral",
              message: "Do you want to delete this referral?",
              includeYes: false,
              isInProgress: _ctx.isDeleteInProgress,
              ok: _ctx.deleteReferral,
              cancel: _ctx.cancelDeleteReferral
            }, null, 8 /* PROPS */, ["isInProgress", "ok", "cancel"])
          ]))
        : _createCommentVNode("v-if", true),
      (_ctx.isNonAdmitRequested)
        ? (_openBlock(), _createElementBlock("td", _hoisted_34, _hoisted_36))
        : _createCommentVNode("v-if", true)
    ], 2 /* CLASS */),
    (_ctx.isNonAdmitRequested)
      ? (_openBlock(), _createElementBlock("tr", _hoisted_37, [
          _createElementVNode("td", {
            colspan: _ctx.columns,
            class: "p-3 edit au-target"
          }, [
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("section", _hoisted_41, [
                  _createElementVNode("div", _hoisted_42, [
                    _hoisted_43,
                    _createVNode(_component_DatePicker, { getDate: _ctx.getNewNonAdmitDate }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_44, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "form-control",
                            placeholder: "MM/DD/YYYY",
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.newNonAdmitData.nonAdmitDate) = $event)),
                            autocomplete: "off"
                          }, null, 512 /* NEED_PATCH */), [
                            [_vModelText, _ctx.newNonAdmitData.nonAdmitDate]
                          ]),
                          _hoisted_45
                        ])
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["getDate"])
                  ]),
                  _createElementVNode("div", _hoisted_46, [
                    _hoisted_47,
                    (!_ctx.showMultiSelect)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                          _createVNode(_component_NewTypeahead, {
                            data: _ctx.nonAdmitReasons,
                            selectedOption: _ctx.selectedNonAdmitReason,
                            "onUpdate:selectedOption": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.selectedNonAdmitReason) = $event)),
                            clearOnBlur: true,
                            placeholder: "Enter Non-Admit Reason"
                          }, null, 8 /* PROPS */, ["data", "selectedOption"])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_49, [
                          _createElementVNode("div", _hoisted_50, [
                            _createVNode(_component_TagsInput, {
                              data: _ctx.nonAdmitReasons,
                              tags: _ctx.mulitpleNonAdmitReasons,
                              placeholder: "Select Non-Admit Reason",
                              onUpdateSelectedOption: _ctx.updateSelectedNonAdmitReason,
                              onUpdateTags: _ctx.updateTags,
                              "open-on-focus": true
                            }, null, 8 /* PROPS */, ["data", "tags", "onUpdateSelectedOption", "onUpdateTags"])
                          ])
                        ]))
                  ])
                ]),
                _createElementVNode("section", _hoisted_51, [
                  (_ctx.showCommentBox)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                        _createElementVNode("label", _hoisted_53, [
                          _hoisted_54,
                          (_ctx.showMultiSelect && _ctx.commentRequired)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_55, "*"))
                            : _createCommentVNode("v-if", true)
                        ]),
                        _createVNode(_component_CommentInput, {
                          "input-name": "nonadmit - comments",
                          result: _ctx.newNonAdmitData.nonAdmitComments,
                          onResultUpdatedAppended: _ctx.resultUpdatedAppended,
                          onResultUpdated: _ctx.resultUpdated,
                          "show-template-typeahead": _ctx.showTemplate,
                          "comment-required": _ctx.commentRequired
                        }, null, 8 /* PROPS */, ["result", "onResultUpdatedAppended", "onResultUpdated", "show-template-typeahead", "comment-required"])
                      ]))
                    : _createCommentVNode("v-if", true)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_56, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary btn-md au-target",
                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.convertToNonAdmit())),
                "au-target-id": "2039"
              }, " Non-Admit "),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-outline-secondary btn-md ms-2 au-target",
                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.closeNonAdmitForm())),
                "au-target-id": "2040"
              }, " Cancel ")
            ])
          ], 8 /* PROPS */, _hoisted_38)
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.isTransferRequested)
      ? (_openBlock(), _createElementBlock("tr", _hoisted_57, [
          _createElementVNode("td", {
            colspan: _ctx.columns,
            class: "p-3 edit"
          }, [
            _createVNode(_component_TransferPatientForm, {
              referral: _ctx.referral,
              isTransferRequested: _ctx.isTransferRequested,
              "onUpdate:isTransferRequested": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.isTransferRequested) = $event))
            }, null, 8 /* PROPS */, ["referral", "isTransferRequested"])
          ], 8 /* PROPS */, _hoisted_58)
        ]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}